import create from 'zustand';

const useStore = create((set) => ({
  audio: null,
  setAudio: (audio) => set({ audio }),

  isAnimating: false,
  startAnimation: () => set({ isAnimating: true }),
  
  isModelAnimationComplete: false,
  setModelAnimationComplete: () => set({ isModelAnimationComplete: true })
}));

export { useStore };